<template>
	<div class="infromation">
		<div class="head">
			<h3>Szerkesztő</h3>
		</div>
		<div class="card" v-if="!loading">

			<div>
				<!--<ui-textbox label="Szervező" floating-label v-model="form.origin"></ui-textbox>-->
				<md-input-container>
					<label>Rendezvény neve</label>
					<md-input v-model="form.title"></md-input>
				</md-input-container>
				<md-input-container>
					<label>Leírás</label>
					<ckeditor v-model="form.description" :config="ckeditor"></ckeditor>
				</md-input-container>
			</div>

			<div class="block">
				<h4>Kapcsolati adatok</h4>
				<attachment-block :attachments="form.attachments"></attachment-block>
			</div>

			<div class="block">
				<h4>Szponzorok</h4>
				<div v-for="(sponsor, index) in form.sponsors" class="row">
					<md-input-container class="col-md-3">
						<label>Név</label>
						<md-input v-model="sponsor.name"></md-input>
					</md-input-container>
					<md-input-container class="col-md-3">
						<label>Weboldal</label>
						<md-input v-model="sponsor.website"></md-input>
					</md-input-container>
					<md-input-container class="col-md-3">
						<label>Kép</label>
						<md-input v-model="sponsor.image"></md-input>
					</md-input-container>

					<md-input-container class="col-md-3">
						<label>Kategória</label>
						<md-select v-model="form.sponsors[index].category">
							<md-option v-for="sponsorCategory in sponsorCategories" :value="sponsorCategory.value">{{sponsorCategory.label}}</md-option>
						</md-select>
					</md-input-container>

					<a class="col-md-1" v-on:click="removeStuff('sponsors',sponsor)"><md-icon>remove_circle_outline</md-icon></a>
				</div>
				<md-button class="md-primary" v-on:click.native="newSponsor">Szponzor hozzáadása</md-button>
			</div>

			<div class="block">
				<h4>Helyszínek</h4>
				<div v-for="(location, index) in locations" class="row">
					<md-input-container class="col-md-3">
						<label>Név</label>
						<md-input v-model="location.name"></md-input>
					</md-input-container>
					<md-input-container class="col-md-2">
						<label>Hosszúság</label>
						<md-input v-model="location.latitude"></md-input>
					</md-input-container>
					<md-input-container class="col-md-2">
						<label>Szélesség</label>
						<md-input v-model="location.longitude"></md-input>
					</md-input-container>
					<md-input-container class="col-md-3">
						<label>Cím</label>
						<md-input v-model="location.address"></md-input>
					</md-input-container>
					<a class="col-md-1" v-on:click="removeLocation(location, index)"><md-icon>remove_circle_outline</md-icon></a>
					<div class="col-md-12 row">
						<a class="col-md-2" v-on:click="loadCoords(location)">Koordináták kitöltése</a>
						<a class="col-md-2" :href="'https://www.google.com/maps/?q=' + location.latitude + ',' + location.longitude" target="_blank">Megtekintés térképen</a>
					</div>
				</div>
				<md-button class="md-primary" v-on:click.native="newLocation">Helyszín hozzáadása</md-button>
			</div>

			<md-button class="md-accent" v-on:click.native="save()">Mentés</md-button>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue'
	import FirebaseDBService from '../../services/FirebaseDBService'
	import moment from 'moment'
	import _ from 'lodash'
	import Ckeditor from "vue-ckeditor2";
	import geocoder from 'geocoder';

	function newInformation(){
		return {
			title: "",
			origin: "",
			description: "",
			sponsors: [],
			locations: [],
			attachments: []
		};
	}

	export default {
		components: {
			'attachment-block': require('./AttachmentBlock'),
			Ckeditor
		},
		data(){
			return {
				loading: true,
				form: newInformation(),
				locations: [],

				sponsorCategories: [{
					label: "Arany",
					value: "gold"
				},{
					label: "Ezüst",
					value: "silver"
				},{
					label: "Bronz",
					value: "bronze"
				}],
				ckeditor: require('../../config.js').default.ckeditor
			}
		},
		methods:{
			newSponsor(){
				this.form.sponsors.push({
					name: "",
					website: "",
					image: "",
					category: this.sponsorCategories[0]
				});
				this.$forceUpdate();
			},
			newLocation(){
				this.locations.push({
					name: "Budapest",
					longitude: "000",
					latitude: "000"
				});
				this.$forceUpdate();
			},
			removeStuff(from,what){
				console.log('Removing');
				_.remove(this.form[from],what);
				this.$forceUpdate();
			},
			removeLocation(location, index){
				console.log('Removing');
				_.pullAt(this.locations,index);
				console.log('this.locations', this.locations);
				FirebaseDBService.deleteLocation(location);
				this.$forceUpdate();
			},
			loadCoords(location){
				geocoder.geocode(location.address + " Hungary", function ( err, data ) {
					console.log('err', err);
					console.log('data', data);
  					if(data.results.length > 0 && data.results[0].geometry) {
  						location.latitude = data.results[0].geometry.location.lat;
						location.longitude = data.results[0].geometry.location.lng;
  					}
				}, { key: "AIzaSyC0eEisEIsBMH6YYQhboH8-V50olkvQAl8" });
			},
			save(){

				FirebaseDBService.saveInformation(this.form);
				for(var location of this.locations){
					FirebaseDBService.saveLocation(location);
				}
			}
		},
		mounted(){
			this.loading = true;
			FirebaseDBService.getInformation((err, informations) => {
				if(informations.length > 0){
					var information = informations[0];
					information.attachments = information.attachments || [];
					information.sponsors = information.sponsors || [];
					information.locations = information.locations || [];
					this.form = information;
				}else{
					this.form = newInformation();
				}
				this.loading = false;
			});

			FirebaseDBService.getLocations((err, locations) => {
				this.locations = locations;
			});
		}
	}
</script>

<style scoped>
	.card{
		background-color: #FFF;
		color: #333;
	}

	.block{
		background-color: #eee;
		padding: 8px;
		margin-bottom: 8px;
	}

	.ckeditor {
		margin-top: 2.5em;
		width: 100%;
	}
</style>



// WEBPACK FOOTER //
// InformationView.vue?5242735e